import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import sanitizeFilename from "sanitize-filename";

export const ticketDownloadMixin = {
    data() {
        return {
            isMobile: window.innerWidth <= 768
        };
    },
    methods: {
        async downloadTicket(ticket) {
            this.$set(this.generatingPDFStates, ticket.qr_access_code, true);

            try {
                const pdf = this.generatePDFInstance();
                const element = document.querySelector(`[data-ticket-id="${ticket.qr_access_code}"]`)
                if (!element) return;

                await this.generatePDFFromElement(element, pdf);
                const fileName = this.generateFileName(ticket);
                const fileNameSanitized = this.sanitizeTicketFilename(fileName);
                pdf.save(fileNameSanitized);
            } catch (error) {
                console.error("Error generating ticket PDF:", error);
            } finally {
                this.$set(this.generatingPDFStates, ticket.qr_access_code, false);
            }
        },

        async downloadAllTickets(batchDownloadId) {
            this.$set(this.generatingPDFStates, batchDownloadId, true);

            try {
                const pdf = this.generatePDFInstance();
                const ticketElements = document.querySelectorAll('.ticket-container');

                for (const [index, element] of ticketElements.entries()) {
                    await this.generatePDFFromElement(element, pdf);
                    if (index < ticketElements.length - 1) {
                        pdf.addPage();
                    }
                }

                const today = new Date();
                const formattedDate = `${today.getDate().toString().padStart(2, '0')}-${(today.getMonth() + 1).toString().padStart(2, '0')}-${today.getFullYear()}`;
                const filename = `ticketsammlung_${formattedDate}.pdf`;

                pdf.save(filename);
            } catch (error) {
                console.error("Error generating ticket PDF:", error);
            } finally {
                this.$set(this.generatingPDFStates, batchDownloadId, false);
            }
        },

        async generatePDFFromElement(element, pdf) {
            const canvas = await html2canvas(element, {
                scale: 2,
                useCORS: true,
                width: this.isMobile ? 800 : 1200,
                windowWidth: this.isMobile ? 800 : 1300
            });
            const imgData = canvas.toDataURL('image/jpeg', 0.75);
            const padding = 10;
            const { paddedWidth, scaledHeight } = this.calculateDimensions(pdf, imgData, padding);
            pdf.addImage(imgData, 'JPEG', padding, padding, paddedWidth, scaledHeight);
        },

        calculateDimensions(pdf, imgData, padding) {
            const imgProps = pdf.getImageProperties(imgData);
            const paddedWidth = pdf.internal.pageSize.getWidth() - (padding * 2);
            const scaledHeight = (imgProps.height * paddedWidth) / imgProps.width;
            return {paddedWidth, scaledHeight}
        },

        generatePDFInstance() {
            return new jsPDF({
                orientation: 'p',
                unit: 'mm',
                format: 'a4'
            });
        },

        sanitizeTicketFilename(fileName) {
            return sanitizeFilename(fileName)
                .toLowerCase()
                .replace(/\s+/g, '_');
        },

        generateFileName(ticket) {
            return `ticket_${this.concert.konzertdaten?.vorst_name}_R${ticket.sipl_reihennr}P${ticket.sipl_platznr}.pdf`;
        }
    },
};
